var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"selectFile":_vm.selectFile}),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.onFileSelected}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }